export const map = (value, low1, high1, low2, high2) =>
	low2 + ((high2 - low2) * (value - low1)) / (high1 - low1);

export const random = (min, max) =>
	Math.floor(Math.random() * (max - min + 1)) + min;

export const formatNumberWithSeperator = (value, seperator = ",") =>
	value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, seperator);
